<footer class="modal-footer">
  <button
    *ngIf="showSecondary"
    mat-button
    type="button"
    [ngClass]="secondaryClass"
    [disabled]="secondaryDisabled"
    (click)="secondary.emit()"
  >
    {{ secondaryLabel }}
  </button>
  <button
    *ngIf="showPrimary"
    mat-button
    type="button"
    [ngClass]="primaryClass"
    [disabled]="primaryDisabled"
    (click)="primary.emit()"
  >
    {{ primaryLabel }}
  </button>
</footer>
